import TopUpStatusMessage from './TopUpStatusMessage';

export const TopUpDeclined = () => {
    return (
        <TopUpStatusMessage heading="Sorry, we can’t approve you for more funds at the moment." />
    );
};
